import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component props
interface SellingValueProps {
	text: string;
	value?: string | number;
	paddingNull?: boolean;
	dispatch?: (action: [string, wts_ignore_any]) => void;
}

export const SellingValue = ( props: SellingValueProps ) => {

	return(
		<p className={"selling-val-text" + (props.paddingNull ? " check-padding": "" )}>
			<span className={"selling-val-text-item"}>{ props.text }</span>
			<span className={"selling-val-text-val" + ( props.value === undefined ? " hidden" : "") } >{ " " + props.value }</span>
		</p>
	);
};